module.exports = __webpack_public_path__ + "static/graf-ae931d062dc457e66b4708a55bbdf8f0.png";